import React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import {AppBar} from "@mui/material";
import Basics from "./forms/Basics";
import GeneralInfo from "./forms/GeneralInfo";
import LivingRoom from "./forms/LivingRoom";
import Kitchen from "./forms/Kitchen";
import Bathroom from "./forms/Bathroom";
import OtherRooms from "./forms/OtherRooms";
import SecondaryRooms from "./forms/SecondaryRooms";
import BuildingExterior from "./forms/BuildingExterior";
import HeatingAndPlumbing from "./forms/HeatingAndPlumbing";
import HealthAndSafety from "./forms/HealthAndSafety";
import Optionals from "./forms/Optionals";
import {GoogleMapsContext} from "../lib/contextLib";
import GoogleMapsServices from "./GoogleMapsServices";

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}

export default function ScrollableTabs() {
    const [value, setValue] = React.useState(0);
    //Load GoogleMapsServices now to ensure dependent fields aren't rendered before services are ready.
    const googleMaps = GoogleMapsServices();
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div>
            <AppBar position={"static"} color={"default"}>
                <Tabs
                    variant="scrollable"
                    scrollButtons
                    value={value}
                    onChange={handleChange}
                    aria-label="scrollable auto tabs"
                    allowScrollButtonsMobile>
                    <Tab label="Basics"  {...a11yProps(0)} />
                    <Tab label={"General Info"}  {...a11yProps(1)}/>
                    <Tab label="Living Room" {...a11yProps(2)} />
                    <Tab label="Kitchen" {...a11yProps(3)} />
                    <Tab label="Bathroom" {...a11yProps(4)} />
                    <Tab label="Other Rooms" {...a11yProps(5)} />
                    <Tab label="Secondary Rooms" {...a11yProps(6)} />
                    <Tab label="Building Exterior" {...a11yProps(7)} />
                    <Tab label={"Heating & Plumbing"} {...a11yProps(8)}/>
                    <Tab label={"Health & Safety"} {...a11yProps(9)}/>
                    <Tab label={"Optional Info"} {...a11yProps(10)}/>
                </Tabs>
            </AppBar>
            <GoogleMapsContext.Provider value={googleMaps}>
                <TabPanel value={value} index={0}>
                    <Basics/>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <GeneralInfo/>
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <LivingRoom/>
                </TabPanel>
                <TabPanel value={value} index={3}>
                    <Kitchen/>
                </TabPanel>
                <TabPanel value={value} index={4}>
                    <Bathroom/>
                </TabPanel>
                <TabPanel value={value} index={5}>
                    <OtherRooms/>
                </TabPanel>
                <TabPanel value={value} index={6}>
                    <SecondaryRooms/>
                </TabPanel>
                <TabPanel index={7} value={value}>
                    <BuildingExterior/>
                </TabPanel>
                <TabPanel index={8} value={value}>
                    <HeatingAndPlumbing/>
                </TabPanel>
                <TabPanel index={9} value={value}>
                    <HealthAndSafety/>
                </TabPanel>
                <TabPanel index={10} value={value}>
                    <Optionals/>
                </TabPanel>
            </GoogleMapsContext.Provider>
        </div>
    );
}
